<template>
  <div id="app">
    <Indicator></Indicator>
    <HeaderBar pre-href="../../" pageName="rebuild"></HeaderBar>
    <ScrollCover
      :cover-bg="detectDevice(require('../public/images/cover/rebuild_yeh_mob_bg.png'), require('../public/images/cover/rebuild_yeh_pad_bg.png') , require('../public/images/cover/rebuild_yeh_pc_bg.png'))"
      :cover-video="detectDevice('https://p3.udn.com.tw/921/rebuild/yeh/rebuild_yeh_vmob.mp4', 'https://p3.udn.com.tw/921/rebuild/yeh/rebuild_yeh_vpad.mp4' , 'https://p3.udn.com.tw/921/rebuild/yeh/rebuild_yeh_vpc.mp4')"
      :cover-video-poster="detectDevice('https://p3.udn.com.tw/921/rebuild/yeh/rebuild_yeh_vmob_bg.jpg', 'https://p3.udn.com.tw/921/rebuild/yeh/rebuild_yeh_vpad_bg.jpg' , 'https://p3.udn.com.tw/921/rebuild/yeh/rebuild_yeh_vpc_bg.jpg')"
      cover-title="災後的天空<br>太平藍站上巴黎"
      cover-subtitle="921地震廿年系列 災區重建故事五"
      intro-name="葉晉玉"
      intro-age="年齡：62歲"
      intro-resume="現職：水源地文教基金會董事長<br>成績單：921地震後在太平災區推廣客家藍染，輔導災民就業，重振在地經濟。創立「太平藍」品牌，多次代表台灣到國外參展。"
    />
    <div id="background-container" class="articleEntry">
      <div  class="container">
        <div class="articleBackgroundParent">
          <div class="articleBackgroundChild"></div>
        </div>
        <div class="articleContent">
          
          <p>不想跟市場競爭「你有多可憐」。921地震之後，在災區堅持20年的葉晉玉這樣說。</p>
          
          <p>車子轉彎進院子時，兩幅不停被風吹翻的藍染長布，吸引眾人的目光，我們便知道「太平藍」的基地到了。在此之前，「太平藍」的品牌陸續出現在2017年巴黎國際家飾展、新加坡、泰國等國際家飾展，2018年獲選經濟部金點設計獎、2019年登上國家文創禮品館。</p>

          <p>卻很少被提及，這是921地震後，太平災區的人們為了求生存，20年來戮力打拚的結果。「我們不想跟別人競爭可憐，」水源地文教基金會董事長葉晉玉淡定的說，他想做的是社會企業，不是可憐企業。</p>
          
        </div>

        <div class="beggingMercy">
          <h3 class="title-margin-top">別說我可憐 用客家藍染重建家園</h3>

          <p>葉晉玉是桃園客家人，小時候跟著家人來到台中定居，地震後，客家的硬頸精神讓他前往太平災區救災，「救災是一時的，這裡的人必須想辦法存活下去。」他形容，太平市好山好水，地震之前是富饒的觀光景點，多年來已發展出成熟的農業休閒旅遊。</p>

          <p>一場地震把地形地貌改變，也把觀光客震走了，昔日的好山好水變成眼前的殘山剩水，以及原本靠山靠水過日子的居民。該怎麼辦？原本在台中擔任大學老師的葉晉玉，心想如何讓當地的居民可以自給自足，不依靠政府補助，既然無法做生態旅遊，改做藍染吧。</p>


        </div>
      </div>
      <div class="title-margin-top">
        <three-iamges-box
            :image-one-src="srcRWD(require('../public/images/rebuild_yeh_mob1.jpg'), require('../public/images/rebuild_yeh_pc1.jpg'))"
            :image-two-src="srcRWD(require('../public/images/rebuild_yeh_mob2.jpg'), require('../public/images/rebuild_yeh_pc2.jpg'))"
            :image-three-src="srcRWD(require('../public/images/rebuild_yeh_mob3.jpg'), require('../public/images/rebuild_yeh_pc3.jpg'))"
            image-one-des=""
            image-two-des="台中太平客家庄曾經發展藍染工藝，921地震後，葉晉玉為了振興在地經濟，帶領社區媽媽投入藍染創作，推出一系列服飾、配件等商品，也吸引大學生前來實習。圖／黃仲裕攝影"
        ></three-iamges-box>
      </div>
      <div class="container">
        <p>太平客家庄舊時曾發展出藍染工藝，但卻在工業化時代消失，要怎麼恢復藍染工藝，從種植藍染植物大菁、小菁開始，葉晉玉在知名景點蝙蝠洞栽種，2008年成立染布工作坊，讓當地苦無工作的居民來學習，有地震受災戶、受暴婦女、中高齡社區媽媽等。社區營造必須能創造收入，這些居民才有穩定的薪水。</p>
        
        <div class="container_quote">
            <p class="container_quote_words">販賣悲情只能撐一時，不如創作出讓人願意購買的商品。</p>
        </div>

        <p>葉晉玉找來藍染工藝師湯文君和亞洲大學時尚設計系主任林青玫加入指導，隨後設計師江婕妤、詹雅汶加入，「太平藍」（Taiping Blue）的品牌才正式成立。</p>

        <h3 class="title-margin-top">社區媽媽 將太平藍推向國際舞台 </h3>

        <p>社區工藝商品化是段艱辛的路，「10幾年前，太平既偏僻，藍染作品也沒有亮點，根本賣不出去，大家坐困愁城、一籌莫展，」葉晉玉說，直到設計團隊加入，賦與藍染新生命，利用藍染可以調出21種顏色，設計出實用的商品，比如最受歐洲人喜愛的時鐘，每一小時的刻度採用不同深淺藍色設計出來。</p>

      </div>

      <div class="containerImage">
        <img class="containerImage_image" :src="srcRWD(require('../public/images/rebuild_yeh_mob4.jpg'), require('../public/images/rebuild_yeh_pc4.jpg'))" alt="">
        <p class="containerImage_description">葉晉玉找來專業設計團隊，打造「太平藍」品牌，將社區工藝商品化，設計出讓外國人驚豔的藍染時尚產品。圖／黃仲裕攝影</p>
      </div>

      <div class="container">
        
          <p>「一群媽媽手工做出來的商品，最初在7-Eleven販售，然後也打入日月潭涵碧樓的商品販賣部，才逐漸被外界看到。」葉晉玉說，現在除了太平當地的弱勢媽媽以外，水源地文教基金會也結合嘉義聽語多重障礙協會的工班，讓多重身障人士代工，靠自己的技術擁有經濟能力。</p>

          <p>葉晉玉說，商品賣得出去，讓社區產生光榮感，他眼裡彷彿還留有20年前觀光客塞滿太平旅遊的景象，「不信客人喚不回。」</p>

          <p>20年前921地震，造成台中縣太平市100多人死傷，2200多戶房屋全倒，聯外交通中斷，客人進不去，居民出不來。現在社區媽媽把雙手染藍，剪裁一張張的藍染布，讓商品站上全世界的舞台，美國、法國、日本、泰國、新加坡、中國大陸。</p>

      </div>

      <EndOfNavBar
        last-url="../cheng/"
        last-name="上一篇"
        next-url="../hsieh/"
        next-name="回首廿年重建路"
        page-number="5/6"
        :is-start="false"
        :is-end="false"
      ></EndOfNavBar>
      <GeneralWidget :useMemory="true"/>
    </div>
  </div>
</template>

<script>
import srcRWD from './mixin/srcRWD.js'
import detectDevice from './mixin/detectDevice.js'
import ScrollCover from '../../share_components/ScrollCover.vue'
import ThreeIamgesBox from '../../share_components/ThreeIamgesBox.vue'
import EndOfNavBar from '../../share_components/EndOfNavBar.vue'
import Indicator from '../../../general_components/Indicator.vue'
import HeaderBar from '../../../general_components/HeaderBar.vue'
import GeneralWidget from '../../../general_components/GeneralWidget.vue'
import Relate from '../../../general_components/Relate.vue'
import Comment from '../../../general_components/Comment.vue'
import Logo from '../../../general_components/Logo.vue'
import Author from '../../../general_components/Author.vue'
import Footer from '../../../general_components/Footer.vue'

export default {
  name: 'app',
  data () {
    return {
      isOverNav: false,
      pinArticleBackground: null
    }
  },
  mixins: [srcRWD, detectDevice],
  components: {
    ScrollCover,
    ThreeIamgesBox,
    EndOfNavBar,
    Indicator,
    HeaderBar,
    GeneralWidget,
    Relate,
    Comment,
    Logo,
    Author,
    Footer
  },
  mounted () {
    let controller = new this.$sm.Controller();
    this.pinArticleBackground = new this.$sm.Scene({triggerElement: ".articleBackgroundParent", duration: '1100%', triggerHook: 'onLeave'})
								.setPin(".articleBackgroundParent", {pushFollowers: false})
                .addTo(controller);
  },
  methods: {

  },
  destroyed () {
    this.pinArticleBackground.remove();
  }
}
</script>

<style lang="scss">

@import "../../../sass/main.scss";
@import "../../share_scss/custom.scss";

#app {
  .articleEntry {
    position: relative;
    width: 100%;
    z-index: 1;
    padding-top: 60px;
    background-color: #fff;
    .articleBackgroundParent {
      position: absolute;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      z-index: -1;
      .articleBackgroundChild {
        width: 100%;
        height: 100%;
        background-image: url("../../share_source/background_mob.jpg");
        background-position: center;
        background-size: cover;
        @media (min-width: 768px) and (max-width: 1279.98px) {
          background-image: url("../../share_source/background_pad.jpg");
        }
        @media (min-width: 1280px) {
          background-image: url("../../share_source/background_pc.jpg");
        }
      }
      .fixedUp {
        position: fixed;
        width: 100%;
        height: 100vh;
        top: 0;
        z-index: 99999;
      }
    }
    .articleContent {
      position: relative;
      z-index: 10;
      color: $gray;
    }
    .rebuild-img {
      width: 100%;
    }
    .rebuild-img-description {
      color: #7b7a7a;
    }
    .socialBelief {

    }
    .rebuildGeneration {
      margin-top: 60px;
    }
  }
}
</style>
